export default __webpack_public_path__ + "static/media/the_italian_dog.687d3c4a.jpg";